module.exports = __webpack_public_path__ + "static/media/gridtypeactive.37f28595.svg";